import React, { useCallback } from 'react';

import {
  AccountManager,
  getActiveForms,
  NotificationManager,
  useApplicationState,
  useVerificationCheck,
} from '@atlas/core';
import { onChangePasswordSubmit, useActiveForm } from '@atlas/react-forms';
import { HeaderTitle, Loader } from '@atlas/ui';

import FormMobile from 'common/Form/FormMobile';
import SeoPageText from 'components/SeoPage/SeoPageText';
import { useFaceCheck } from 'src/components/ClientProfile/useFaceCheck';

const ChangePassword = () => {
  const { account } = useApplicationState();
  const { docNumber, firstName, lastName } = account;

  const { isNeedFaceCheck } = useFaceCheck();

  const { verify } = useVerificationCheck({
    docNumber,
    firstName,
    lastName,
    onError: () => {
      NotificationManager.notify({
        message: 'legitimuz_face_check_error',
        status: 'error',
        type: 'notification',
      });
    },
    onSuccess: () => {
      submit();
    },
    verificationType: 'facecheck',
  });

  const { activeStep, activeType, submit } = useActiveForm(
    'CHANGE_PASSWORD',
    onChangePasswordSubmit(AccountManager.changePasswordWithForm.bind(AccountManager)),
    getActiveForms,
  );

  const submitHandler = useCallback(() => {
    if (isNeedFaceCheck) return;

    NotificationManager.notify({
      message: 'change_password_title',
      status: 'success',
      type: 'notification',
    });
  }, [isNeedFaceCheck]);

  if (!activeType) {
    return <Loader className="profile-loader relative" />;
  }

  return (
    <>
      <div className="title-wrapper">
        <HeaderTitle className="sub-text block-medium border" title="profile_change_password" />
      </div>

      <div className="change-password-container">
        <div className="form-container">
          <FormMobile
            action={isNeedFaceCheck ? verify : submit}
            buttonText={isNeedFaceCheck ? 'verify' : 'save'}
            form={{ fields: activeType?.steps[0]?.fields, number: activeStep }}
            onSubmit={submitHandler}
          />
        </div>
      </div>
      <SeoPageText />
    </>
  );
};

export default ChangePassword;
